import InputComponent from "V2.0/components/InputComponent";
import { Switch } from "V2.0/common/switch";
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";

function DisabledInfo() {
  return (
    <div className="flex gap-x-2 items-center w-full text-wrap">
      <ExclamationCircleIcon className="text-blue-500 size-4" />
      <p className="font-xs text-xs text-blue-500">
        If turned OFF, the assistant will wait for the User to speak first
      </p>
    </div>
  );
}

export default function OutboundWelcomeMessageSettings(props) {
  const { welcomeMessageSettings, onUpdate, onSave, locked } = props;

  function handleToggleInitiateOutbound() {
    onUpdate({
      shouldAgentSpeakFirstOutbound:
        !welcomeMessageSettings.shouldAgentSpeakFirstOutbound,
    });
  }

  function handleUpdateOutboundMessage(outboundWelcomeMessages) {
    onUpdate({
      outboundWelcomeMessages,
    });
  }

  return (
    <div className="grid grid-cols-3 space-y-4">
      <div className="flex flex-col gap-y-2 col-span-3">
        <div className=" flex gap-x-4 items-center">
          <p className="text-sm font-semibold">Assistant Initiates Conversation</p>
          <Switch
            color="emerald"
            checked={welcomeMessageSettings.shouldAgentSpeakFirstOutbound}
            onClick={handleToggleInitiateOutbound}
            disabled={locked}
          />
        </div>
        <DisabledInfo />
      </div>
      <div className="col-span-3 ml-4">
        <InputComponent
          type="textArea"
          label="Message"
          value={welcomeMessageSettings.outboundWelcomeMessages}
          disabled={
            locked || !welcomeMessageSettings.shouldAgentSpeakFirstOutbound
          }
          style={{ height: "100px", fontSize: "13px" }}
          onChange={(e) => handleUpdateOutboundMessage(e.target.value)}
        />
      </div>
    </div>
  );
}
